export const NICOTINE_USAGE_EMPLOYEE = 'NICOTINE_USAGE_EMPLOYEE';

export const hasNicotineUsageQuestionSelector = (state) => {
    const memberGroupKey = state.memberElection.memberGroups[0];
    return state.policyData.billGroupData
        .memberGroups
        .filter(memberGroup => memberGroup.memberGroupKey === memberGroupKey)
        .flatMap(memberGroup => memberGroup.coverageQuestions)
        .some(coverageQuestion => coverageQuestion.labelAliasName === NICOTINE_USAGE_EMPLOYEE);
};